import React from 'react';

import BusinessInfoBack from './BackFlow';
import BusinessInfoFront from './FrontFlow';

const BusinessInfo = ({
  businessId,
  form,
  flow,
}) => {

  if (flow === 'back') {
    return <BusinessInfoBack businessId={businessId} form={form} />;
  }

  return <BusinessInfoFront businessId={businessId} form={form} />;
};

export default BusinessInfo;
